import { services } from '../services';
var action = "stockjournalentry";

export const stockjournalentryService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    getListByJournal,
    saveNotaion,
    savePayment
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}

function getListByJournal(id) {
    return services.restApi(`${action}/journal/${id}`, 'GET');
}

function saveNotaion(object) {
    return services.restApi(`${action}/notation`, 'POST', object);
}

function savePayment(object) {
    return services.restApi(`${action}/paid`, 'POST', object);
}